<template>
  <div class="h5-index-wrapper">
    <UserInfo :user="user" :isActivityEmpty="true" />

    <div v-if="false">
      <section class="date-wrapper">
        <BtnPicker class="date-btn" :items="dateItems" @on-change-date="onChangeDate" />
        <datetime class="date-picker" v-model="dateItem" format="kkkk-LL-dd" />
      </section>

      <MpAccount :user="user" />
      <MpAccount :user="user" />
    </div>

    <div v-if="userStates === 'disable'">
      <section class="head">
        <label :class="['title', isKeyError ? 'error' : '']">{{isKeyError ? '错误！' : '重要！'}}</label>
        <p class="tip">您还没有裂变活动，点下方按钮创建<br />您还没有裂变活动，点下方按钮创建</p>
      </section>

      <section class="input">
        <input class="input-box" placeholder="请在此输入邀请者的推荐码" v-model="inviterKey" />
        <span class="submit" @click="partnerLogin">递交</span>
      </section>
    </div>

    <div v-if="userStates === 'enable'">
      <section class="activity">
        <p class="tip">您还没有裂变活动，点下方按钮创建</p>
        <p class="tip">简单设置<i>3</i>分钟搞定，<i>免费</i>增粉赚钱</p>
        <router-link to="/h5/pc/" class="create-btn">新建裂变活动</router-link>
      </section>

      <section class="distribution" v-if="false">
        <p class="tip">您也可以邀请好友使用本工具，赚取分销收入</p>
        <router-link to="/" class="link">查看分销规则</router-link>
      </section>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { utils } from '@/util/index'
import Profiles from '@/engine/Profiles'

import UserInfo from '@/components/h5/UserInfo.vue'
import MpAccount from '@/components/h5/MpAccount.vue'
import BtnPicker from '@/components/h5/BtnPicker.vue'

const state = {
  selectedDate: 'all',
}

export default {
  name: 'h5Index',
  components: {
    UserInfo,
    MpAccount,
    BtnPicker,
  },
  data () {
    return {
      user: {},
      // dateItem: moment().toISOString(),
      dateItem: '',
      userStates: '',
      isKeyError: false,
      inviterKey: '',
      dateItems: [{
        name: '全部',
        value: 'all',
        isActive: true,
      }, {
        name: '本月',
        value: 'month',
        isActive: false,
      }, {
        name: '本周',
        value: 'week',
        isActive: false,
      }, {
        name: '本日',
        value: 'day',
        isActive: false,
      }],
    }
  },
  mounted () {
    this.user = this.globalData.user

    const { inviterKey } = utils.formatQuery(this.$route.query)
    Profiles.partnerLogin(inviterKey).then((data) => {
      this.userStates = data ? 'enable' : 'disable'
    })
  },
  methods: {
    onChangeDate: function ({ value }) {
      this.dateItems = this.dateItems.map((item) => {
        if (item.value === value) {
          state.selectedDate = value
          this.dateItem = ''
        }
        return {
          ...item,
          isActive: item.value === value,
        }
      })
    },
    partnerLogin: function () {
      Profiles.partnerLogin(this.inviterKey).then((data) => {
        if (data) {
          this.userStates = 'enable'
        } else {
          this.isKeyError = true
        }
      })
    },
  },
  watch: {
    dateItem(date) {
      if (date) {
        state.selectedDate = date
        this.dateItems = this.dateItems.map((item) => {
          return {
            ...item,
            isActive: false,
          }
        })
      }
    },
  }
};
</script>

<style src="./index.scss" lang="scss"></style>
